import React from 'react';
import can_logo_png from './can_logo_url_dark.png';

const LogoDarkWithURL = () => (
  <img src={can_logo_png} alt="Covid Act Now Logo"></img>
);

export default LogoDarkWithURL;
